import script from "/app/pages/Home/dropzone.vue?type=script";
import { render } from "/app/pages/Home/dropzone.vue?type=template";
script.render = render;
export default script;
